// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OU6z","textarea":"styles_textarea__17WBL"};